import { FC } from 'react';

interface IProps {}

const Empty: FC<IProps> = () => {
    return <div className="ucr__error-message">No HCPs available for this date</div>;
};

export default Empty;
